export const URL = 'https://cdn.riskid.security/sdk/web_sdk_latest.js'
export const SERVER_PATH = '/e/api.eu.transmitsecurity.io/risk-collect/'
